/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pipelines_DeleteInputs */

const cs_pipelines_delete = /** @type {(inputs: Pipelines_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Smazat pipeline`)
};

const en_pipelines_delete = /** @type {(inputs: Pipelines_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete pipeline`)
};

/**
* | output |
* | --- |
* | "Delete pipeline" |
*
* @param {Pipelines_DeleteInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pipelines_delete = /** @type {((inputs?: Pipelines_DeleteInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pipelines_DeleteInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pipelines_delete(inputs)
	return cs_pipelines_delete(inputs)
});